// extracted by mini-css-extract-plugin
export default {"answers":"Answers_answers__K6-Zt","answers-list":"Answers_answers-list__4KqV3","is-selected":"Answers_is-selected__m5DRO"};